import { useContext } from 'react';
import { AuthGateContext } from '@/auth-gate';
import { BillingDialog } from '@/billing/section';
import { useCompany } from './context';

/** Company admission remains the first destination, including Stripe returns. */
export function CompanyBillingDialog({ beforeRedirect }: { beforeRedirect: () => void }) {
  const auth = useContext(AuthGateContext);
  const company = useCompany();
  if (auth.needsAuth || !company.ready) return null;
  return <BillingDialog beforeRedirect={beforeRedirect} />;
}
